import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../store';
import { UserRole } from '../../types';

const ROLE_LEVEL: Record<string, number> = {
  SUPER_ADMIN: 3,
  GROUP_ADMIN: 2,
  TENANT_ADMIN: 2,
  SALES_REP: 1,
};

interface RequireRoleProps {
  minRole?: UserRole;
  allowedRoles?: UserRole[];
}

/** Returns the home route for a given role */
function homeForRole(role: string | undefined): string {
  if (role === UserRole.SUPER_ADMIN) return '/tenants';
  if (role === UserRole.GROUP_ADMIN) return '/group-admin';
  return '/dashboard';
}

const RequireRole: React.FC<RequireRoleProps> = ({ minRole, allowedRoles }) => {
  const userRole = useAuthStore((s) => s.user?.role);

  if (allowedRoles) {
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to={homeForRole(userRole)} replace />;
    }
  } else if (minRole) {
    const userLevel = ROLE_LEVEL[userRole ?? ''] ?? 0;
    const requiredLevel = ROLE_LEVEL[minRole] ?? 0;
    if (userLevel < requiredLevel) {
      return <Navigate to={homeForRole(userRole)} replace />;
    }
  }

  return <Outlet />;
};

export default RequireRole;
